import { getProfile, getProjects } from "./storageService";
import { ChatMessage } from "../types";

const ERROR_REPLY =
  "I'm having trouble connecting to my brain right now. Please try again later.";

export const getChatResponse = async (
  message: string,
  history: ChatMessage[]
) => {
  try {
    const [profile, projects] = await Promise.all([getProfile(), getProjects()]);

    const res = await fetch("/api/chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ message, history, profile, projects }),
    });

    const data = await res.json();
    return (data?.reply as string) || ERROR_REPLY;
  } catch (error) {
    console.error("Gemini API Error:", error);
    return ERROR_REPLY;
  }
};
